module.exports = __webpack_public_path__ + "static/media/pic9.3296813c.jpg";